const appState = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_DEVICES_ERROR_COUNT':
            return Object.assign({}, state, {
                devicesErrorCount: action.count
            });
        default:
            return state
    }
 }
  
  export default appState